import script from "./OnlineMessageFileContentDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineMessageFileContentDescription.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineMessageFileContentDescription.vue?vue&type=style&index=0&id=d03cd88a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d03cd88a"]])

export default __exports__